import { useLocalStorage } from "usehooks-ts";
import { usePagePrefs } from "@pepsico/pref-permissions";
import { LandingCardGrid } from "@pepsico/layout";

import { usePermissions } from "components/UserProvider";
import { APP_TITLE, appPages, workflowOrder } from "defs";

const Landing: React.FC = () => {
  const permissions = usePermissions();
  const [, isReady] = usePagePrefs();
  const [lastPage] = useLocalStorage<string | null>("lastpage", null);

  if (lastPage && !isReady) {
    return null;
  }

  return (
    <>
      <title>{`${APP_TITLE} - Home`}</title>
      <LandingCardGrid
        appPages={appPages}
        permissions={permissions}
        workflowOrder={workflowOrder}
      />
    </>
  );
};

export default Landing;
